module.exports = __webpack_public_path__ + "static/media/amazon-de-icon.bb9ac88e.svg";